import { cn } from '@/utlis/cn'
import './loader.css'

type LoaderProps = {
    className?: string
    width?: string
    bars?: number
}
export function Loader(props: LoaderProps) {
    const bars = props.bars ?? 7
    return (
        <div className="loader" style={{ width: props.width ?? '100%' }}>
            {Array(bars)
                .fill(0)
                .map((_, i) => (
                    <span className={cn('stroke bg-neutral-200', props.className)} key={i}></span>
                ))}
        </div>
    )
}
